@if (data) {
  <div
    [class]="'text-block ' + contentBgColor + ' ' + contentLayout"
    [ngClass]="{ 'text-block--with-padding': hasPadding, 'text-block__in-modal': parent === 'modal' }"
  >
    @if (
      (contentLayout === "full" && allowBackgroundFullWidthBleed) ||
      (contentLayout === "narrow" && allowBackgroundFullWidthBleed)
    ) {
      <div [class]="['background-panel', contentBgColor]"></div>
    }
    <div class="text-block__container" lgContainer>
      @if (textBlockStyleStandard) {
        <div lgRow>
          <div [lgColMd]="isInNarrowContentArea ? 12 : 8" [lgCol]="12">
            @if (headingComponent) {
              <dotcom-frontend-loader [componentData]="headingComponent" />
            }
            <div
              [innerHTML]="textBlockText | safeHtml"
              [wysiwygContainer]="'Text Component'"
              class="text-block__text wysiwyg"
              dotcomFrontendWysiwyg
            ></div>
          </div>
        </div>
      } @else {
        <div lgRow class="text-block__title-left">
          <div
            [lgColMd]="headingComponentTitle && !isInNarrowContentArea ? 4 : 0"
            [lgColSm]="12"
            [lgCol]="12"
          >
            @if (headingComponentTitle) {
              <dotcom-frontend-loader [componentData]="headingComponentTitle" />
            }
          </div>
          <div [lgColMd]="8" [lgColSm]="12" [lgCol]="12">
            @if (headingComponentSubtitle) {
              <dotcom-frontend-loader
                [componentData]="headingComponentSubtitle"
              ></dotcom-frontend-loader>
            }
            <div
              [innerHTML]="textBlockText | safeHtml"
              [wysiwygContainer]="'Text Component'"
              class="text-block__text wysiwyg"
              dotcomFrontendWysiwyg
            ></div>
          </div>
        </div>
      }

      @if (followUpButtons) {
        <div lgRow>
          <div [lgCol]="12">
            @for (button of followUpButtons; let i = $index; track i) {
              <dotcom-frontend-loader
                [componentData]="button"
                cssClass="followup-cta-button"
              />
            }
          </div>
        </div>
      }
    </div>
  </div>
}
